/**
 * NOTE: SelectionUtils was mainly taken from EditorJS, due to the fact that it
 * is required to properly create a custom LinkInlineTool. EditorJs does not
 * expose all required methods, so we had to copy it.
 * ==> Issue: https://github.com/codex-team/editor.js/issues/1066
 *
 * @see https://github.com/codex-team/editor.js/blob/737ba2abb423665257cf6ccc5e8472742433322f/src/components/selection.ts
 */

class SelectionUtils {
	instance = null;
	selection = null;
	savedSelectionRange = null;
	isFakeBackgroundEnabled = false;
	commandBackground = "backColor";
	commandRemoveFormat = "removeFormat";

	static get range() {
		const selection = window.getSelection();
		return selection && selection.rangeCount ? selection.getRangeAt(0) : null;
	}

	static get text() {
		return window.getSelection ? window.getSelection().toString() : "";
	}

	static get() {
		return window.getSelection();
	}

	removeFakeBackground() {
		if (!this.isFakeBackgroundEnabled) {
			return;
		}
		this.isFakeBackgroundEnabled = false;
		document.execCommand(this.commandRemoveFormat);
	}

	setFakeBackground() {
		document.execCommand(this.commandBackground, false, "#a8d6ff");
		this.isFakeBackgroundEnabled = true;
	}

	save() {
		this.savedSelectionRange = SelectionUtils.range;
	}

	restore() {
		if (!this.savedSelectionRange) {
			return;
		}
		const sel = window.getSelection();
		sel.removeAllRanges();
		sel.addRange(this.savedSelectionRange);
	}

	clearSaved() {
		this.savedSelectionRange = null;
	}

	collapseToEnd() {
		const sel = window.getSelection();
		const range = document.createRange();

		range.selectNodeContents(sel.focusNode);
		range.collapse(false);
		sel.removeAllRanges();
		sel.addRange(range);
	}


	findParentTag(tagName, className, searchDepth = 10) {
		const selection = window.getSelection();

		let parentTag = null;

		/**
		 * If selection is missing or no anchorNode or focusNode were found then return null
		 */
		if (!selection || !selection.anchorNode || !selection.focusNode) {
			return null;
		}

		/**
		 * Define Nodes for start and end of selection
		 */
		const boundNodes = [
			/** the Node in which the selection begins */
			selection.anchorNode,
			/** the Node in which the selection ends */
			selection.focusNode
		];

		/**
		 * For each selection parent Nodes we try to find target tag [with target class name]
		 * It would be saved in parentTag variable
		 */
		boundNodes.forEach((parent) => {
			/** Reset tags limit */
			let searchDepthIterable = searchDepth;

			while (searchDepthIterable > 0 && parent.parentNode) {
			/**
			 * Check tag's name
			 */
			if (parent.tagName === tagName) {
				/**
				 * Save the result
				 */
				parentTag = parent;

				/**
				 * Optional additional check for class-name mismatching
				 */
				if (className && parent.classList && !parent.classList.contains(className)) {
				parentTag = null;
				}

				/**
				 * If we have found required tag with class then go out from the cycle
				 */
				if (parentTag) {
				break;
				}
			}

			/**
			 * Target tag was not found. Go up to the parent and check it
			 */
			parent = parent.parentNode
			searchDepthIterable--;
			}
		});

		/**
		 * Return found tag or null
		 */
		return parentTag;
	}

	expandToTag(element) {
		const selection = window.getSelection();

		selection.removeAllRanges();
		const range = document.createRange();

		range.selectNodeContents(element);
		selection.addRange(range);
	}


}

export default SelectionUtils;